import { FormProvider } from "react-hook-form";
import { TreeView } from "@mui/lab";
import TreeParent from "./TreeParent";
import { Popup } from "@grapecity/wijmo.react.input";
import { Stack, Button } from "@mui/material";
import colors from "assets/scss/colors.scss";
import Add from "@mui/icons-material/Add";
import Remove from "@mui/icons-material/Remove";
import { useEffect } from "react";
import { authorizedGenApiCall } from "api/genApiCalls";
import { apiDataKeyCOLSUserStateSave } from "api/ApiDatakeys";
import { useSelector } from "react-redux";

const ColumnPicker = (props) => {
  const { columns, popupInitialized, gridRef, methods } = props;
  const onSubmit = (data) => {
    saveColumnPickerSettings();
  };

  const saveColumnPickerSettings = async () => {
    let submitJSON = [];
    const data = methods?.getValues();
    for (const property in data) {
      columns?.forEach((column) => {
        const res = column?.children?.find((item) => item.fldName === property);

        if (res)
          submitJSON.push({ fldId: res.fldId, isSelected: data[property] });
      });
    }
    const res = await authorizedGenApiCall({
      dataKey: apiDataKeyCOLSUserStateSave,
      data: JSON.stringify(submitJSON),
    });
    // console.log(res?.status, "Colpicker");
  };

  useEffect(() => {
    const handleTabClose = (event) => {
      event.preventDefault();
      saveColumnPickerSettings();
    };

    window.addEventListener("beforeunload", handleTabClose);

    return () => {
      window.removeEventListener("beforeunload", handleTabClose);
    };
  }, []);

  if (columns?.length > 0)
    return (
      <Popup
        initialized={popupInitialized}
        lostFocus={saveColumnPickerSettings}
      >
        <Stack style={{ maxHeight: "96vh", overflowY: "auto" }}>
          <div
            className="wj-dialog-header Qub-DatagridBringValueView"
            style={{ backgroundColor: colors.bringValueHeader }}
          >
            <div>
              <h6 style={{ marginBottom: 0, marginTop: 0 }}>ΣΤΗΛΕΣ</h6>
            </div>
            <button
              type="button"
              style={{ cursor: "pointer" }}
              tabIndex={-1}
              className="close wj-hide"
            >
              &times;
            </button>
          </div>
          <Stack sx={{ padding: 2 }}>
            <FormProvider {...methods}>
              <TreeView
                aria-label="multi-select"
                defaultCollapseIcon={<Remove />}
                defaultExpandIcon={<Add />}
                defaultExpanded={columns.map((c) => c.grpDescr)}
                multiSelect
                sx={{}}
              >
                {columns.map((category) => (
                  <TreeParent
                    methods={methods}
                    key={category.grpDescr}
                    category={category}
                    gridRef={gridRef}
                  />
                ))}
              </TreeView>
            </FormProvider>
            <Button onClick={() => methods.handleSubmit(onSubmit)()} />
          </Stack>
        </Stack>
      </Popup>
    );
};

export default ColumnPicker;
